import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { PackageModel } from '@/models'
import { composeFormData } from '@/utils'
import { resetQueries } from '@/utils/api'

interface CheckoutPackageRequest {
  id: number
  comment: string
  signature: string
}

export const checkoutPackage = async ({
  id,
  ...data
}: CheckoutPackageRequest): Promise<PackageModel> => {
  const response = await authAPI.put<PackageModel>(`/packages/${id}`, composeFormData(data), {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
  return response.data
}

export const useCheckoutPackage = () => {
  return useMutation({
    mutationFn: checkoutPackage,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
